import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import type { EChartsOption } from 'echarts';
import { ChartComponentProps, getBaseOption, formatTooltipValue, ECHARTS_OPTS, getCategoryValue, toNumericValue } from './chartConfig';

export const FunnelChart: React.FC<ChartComponentProps> = ({ chart, height = 320, colors }) => {
  const option = useMemo((): EChartsOption => {
    const data = chart.data || [];
    if (data.length === 0) return {};

    const base = getBaseOption(colors);

    return {
      ...base,
      tooltip: {
        ...(base.tooltip as object),
        trigger: 'item',
        formatter: (params: unknown) => {
          const p = params as { name?: string; value?: number; percent?: number; marker?: string };
          return `<div style="font-size:12px">${p.marker}<b>${p.name}</b><br/>${formatTooltipValue(p.value)}</div>`;
        },
      },
      legend: { ...base.legend, orient: 'vertical' as const, left: 'left', top: 'middle' as const },
      series: [
        {
          type: 'funnel',
          left: '20%',
          width: '60%',
          top: 30,
          bottom: 20,
          sort: 'descending' as const,
          gap: 2,
          label: { show: true, position: 'inside' as const, formatter: '{b}: {c}', fontSize: 11 },
          data: data.map((d) => ({ name: getCategoryValue(d), value: toNumericValue(d.value) })),
          itemStyle: { borderColor: '#fff', borderWidth: 1 },
          emphasis: { label: { fontSize: 13 } },
        },
      ],
    };
  }, [chart, colors]);

  return <ReactECharts option={option} style={{ height }} notMerge lazyUpdate opts={ECHARTS_OPTS} />;
};
